import React from 'react';

import Switch from '../../common/inputs/customs/switch';
import SelectInput from '../../common/inputs/select-input';
import { Option } from './types';

interface Props {
  isEnabled: boolean;
  onToggle: (value: boolean) => void;
  options: Option[];
  selectedOption: Option;
  onOptionChange: (option: Option) => void;
}

const PlatformSettings = ({
  isEnabled,
  onToggle,
  options,
  selectedOption,
  onOptionChange
}: Props) => (
  <>
    <Switch
      title="Floating Bell Notifications"
      description="The Bell will appear on all site pages"
      value={isEnabled}
      onChange={onToggle}
    />

    <SelectInput
      title="Bell Icon location"
      onChange={onOptionChange}
      options={options}
      value={selectedOption}
      className={'bellIcon'}
    />
  </>
);

export default PlatformSettings;
